/* HustleKing — selettore modello + pacchetto (stile Aurevion) */
(function () {
  'use strict';

  function euro(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function qtyOf(label) {
    var m = String(label).match(/\d+/);
    return m ? parseInt(m[0], 10) : 1;
  }
  function setAll(root, sel, text) {
    root.querySelectorAll(sel).forEach(function (el) { el.textContent = text; });
  }

  function init() {
    var root = document.querySelector('[data-hk-pdp]');
    if (!root) return;

    var data;
    try { data = JSON.parse(root.getAttribute('data-hk-pdp')); } catch (e) { return; }
    if (!data || !data.variants || !data.variants.length) return;

    var optModel = data.optModel;
    var optPack = data.optPack;

    var priceWas = root.querySelector('[data-hk-was]');
    var priceOff = root.querySelector('[data-hk-off]');
    var unitLine = root.querySelector('[data-hk-unit]');

    function selected(name) {
      var el = root.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }
    function find(model, pack) {
      return data.variants.filter(function (v) {
        var okM = !optModel || v.o[optModel] === model;
        var okP = !optPack || v.o[optPack] === pack;
        return okM && okP;
      })[0];
    }

    function paintPacks() {
      var model = selected('hk-model');
      root.querySelectorAll('[data-hk-packrow]').forEach(function (row) {
        var v = find(model, row.getAttribute('data-hk-packrow'));
        if (!v) return;
        var n = qtyOf(row.getAttribute('data-hk-packrow'));
        var p = row.querySelector('[data-hk-pp]');
        var w = row.querySelector('[data-hk-pw]');
        var s = row.querySelector('[data-hk-ps]');
        var e = row.querySelector('[data-hk-pe]');
        if (p) p.textContent = euro(v.p);
        if (w) {
          if (v.c && v.c > v.p) { w.textContent = euro(v.c); w.style.display = ''; }
          else { w.style.display = 'none'; }
        }
        if (s) {
          if (v.c && v.c > v.p) { s.textContent = 'Risparmi ' + euro(v.c - v.p); s.style.display = ''; }
          else { s.style.display = 'none'; }
        }
        if (e) e.textContent = euro(Math.round(v.p / n)) + ' / ordine';
      });
    }

    function paint() {
      var pack = selected('hk-pack');
      var v = find(selected('hk-model'), pack);
      if (!v) return;

      root.querySelectorAll('[data-hk-id]').forEach(function (el) { el.value = v.id; });
      setAll(root, '[data-hk-now]', euro(v.p));
      setAll(root, '[data-hk-btnprice]', euro(v.p));

      if (priceWas) {
        if (v.c && v.c > v.p) { priceWas.textContent = euro(v.c); priceWas.style.display = ''; }
        else { priceWas.style.display = 'none'; }
      }
      if (priceOff) {
        if (v.c && v.c > v.p) {
          priceOff.textContent = '−' + Math.round((1 - v.p / v.c) * 100) + '%';
          priceOff.style.display = '';
        } else { priceOff.style.display = 'none'; }
      }
      if (unitLine) {
        var n = qtyOf(pack || '1');
        unitLine.textContent = n > 1
          ? (euro(Math.round(v.p / n)) + ' per ordine · ' + n + ' ordini inclusi · accesso a vita')
          : 'IVA inclusa · 1 ordine incluso · accesso a vita';
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'hk-model' || e.target.name === 'hk-pack') {
        paintPacks();
        paint();
      }
    });

    paintPacks();
    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
